import { LoggerService } from './../../../../../services/logger/logger.service';
import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { EMachineType } from 'src/app/enums/machine-type.enum';
import { InputAccessoriesService } from 'src/app/services/input-accessories/input-accessories.service';

@Injectable({
	providedIn: 'root',
})
export class UserDefinedKeyFeature {
	constructor(
		private logger: LoggerService,
		private commonService: CommonService,
		private keyboardService: InputAccessoriesService
	) {}

	public async getCapabililty(): Promise<boolean> {
		let isCapable = false;
		const machineType = await this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineType
		);

		if (machineType === EMachineType.ThinkPad) {
			isCapable = await this.getUserDefinedKeyCapability();
			this.logger.info('UserDefinedKeyFeature capability: ', isCapable);

			return isCapable;
		}

		this.logger.info('UserDefinedKeyFeature capability: ', isCapable);
		return isCapable;
	}

	private async getUserDefinedKeyCapability(): Promise<boolean> {
		try {
			const intelligentKeyboardCapabilities = await this.keyboardService.GetAllCapability();
			const hasUserDefinedKeyCapability =
				Object.keys(intelligentKeyboardCapabilities).indexOf('uDKCapability') !== -1
					? intelligentKeyboardCapabilities.uDKCapability
					: false;

			return hasUserDefinedKeyCapability;
		} catch (error) {
			this.logger.error('userDefinedKeyFeature error: ', error.message);
			return false;
		}
	}
}
